import React from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../assets/1.jpg';
import contactImage from '../assets/contact.jpg';
import {  MdPhone, MdLocationOn } from 'react-icons/md';

const Contact = () => {
  const offices = [
    {
      name: "Corporate Office",
      company: "WVT Elevators Private Limited",
      address: "Office No. 77, 3rd Floor, City Court Building, Zirakpura Shimla Highway NH 5, Guru Gobind Singh Nagar, Dhakoli, Panchkula, Zirakpur, Punjab 140603",
      mobile: "9999762470",
      tollFree: "18008918455",
    },
    {
      name: "WVT Elevators Private Limited",
      company: "",
      address: "Bridge No. 05, National Highway 44, Sujanpur, Distt. Pathankot, Punjab – 145023",
      mobile: "9811484679",
      tollFree: "18008918455",
    },
    {
      name: "WVT Elevators Private Limited",
      company: "",
      address: "Office No. 01, Jalapur Phulwariya Road Laudhana Sohgupur, Ambedkar Nagar – 224149",
      mobile: "9999762470",
      tollFree: "18008918455",
    },
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[400px] md:h-[300px] bg-cover bg-center flex flex-col justify-center px-6"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <h1 className="text-white text-4xl md:text-5xl font-bold drop-shadow-lg">FEEL FREE TO CONTACT US</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Contact
        </div>
      </div>

      {/* Offices Section */}
      <div className="max-w-7xl mx-auto py-12 px-6 flex flex-col md:flex-row gap-10">
        {/* Contact Info */}
        <div className="flex-1 space-y-6">
          {offices.map((office, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition">
              <h2 className="text-2xl font-bold text-red-600 mb-2">{office.name}</h2>
              {office.company && <h5 className="text-lg font-semibold mb-2">{office.company}</h5>}
              <p className="flex items-start text-gray-700 mb-2">
                <MdLocationOn className="mr-2 mt-1 text-red-500" /> {office.address}
              </p>
              <p className="flex items-center text-gray-700">
                <MdPhone className="mr-2 text-red-500" /> Mobile: {office.mobile} | Toll-Free: {office.tollFree}
              </p>
            </div>
          ))}
        </div>

        {/* Contact Image */}
        <div className="flex-1 flex justify-center md:justify-end">
          <img
            src={contactImage}
            alt="Contact"
            className="w-full max-w-md rounded-xl shadow-lg object-cover"
          />
        </div>
      </div>

      {/* Send Us a Message Section */}
      <div className="max-w-7xl mx-auto py-12 px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-red-600 mb-10">SEND US A MESSAGE</h2>

        <div className="flex flex-col md:flex-row gap-10">
          {/* Form */}
          <div className="flex-1 bg-white p-8 rounded-xl shadow-lg">
            <form className="space-y-6">
              <div>
                <label className="block mb-1 font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  placeholder="Your Name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  placeholder="Your Email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">Subject</label>
                <input
                  type="text"
                  placeholder="Subject"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">Message</label>
                <textarea
                  rows={5}
                  placeholder="Write your message..."
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                ></textarea>
              </div>
              <div className="flex justify-center">
                <button
                  type="submit"
                  className="px-8 py-3 rounded-lg bg-gradient-to-r from-red-500 to-red-700 text-white font-semibold shadow-md hover:scale-105 transition"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>

          {/* Map */}
          <div className="flex-1">
            <iframe
              title="WVT Elevators Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3490.123456789!2d77.294123!3d28.644123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3ab1234567%3A0xabcdef1234567890!2sDelhi!5e0!3m2!1sen!2sin!4v1696301234567"
              width="100%"
              height="100%"
              className="rounded-xl shadow-lg min-h-[400px]"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
